import { Box, Slider, SliderThumb, styled } from "@mui/material";

interface ClipperSliderProps {
  isAudioFile?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ClipperSlider = styled(Slider)<ClipperSliderProps>(({ theme, isAudioFile }) => ({
  color: "#239B8B",
  padding: "10px 0",
  maxHeight: "100%",
  // pointerEvents: "none",
  "& .MuiSlider-thumb": {
    height: "30px",
    width: "14px",
    backgroundColor: "#fff",
    border: "1px solid currentColor",
    borderRadius: "10px 10px 4px 4px",
    cursor: "col-resize",
    "&:hover": {
      boxShadow: "0 0 0 8px rgba(58, 133, 137, 0.16)",
    },
    "& .clipper-bar": {
      height: 9,
      width: 2,
      backgroundColor: "currentColor",
      marginLeft: 1,
      marginRight: 1,
    },
    // pointerEvents:"all",
  },
  "& .MuiSlider-track": {
    height: "24px",
    borderRadius: 0,
  },
  "& .MuiSlider-rail": {
    color: "#d8d8d8",
    opacity: 1,
    height: "24px",
    borderRadius: 0,
    background: isAudioFile ? "#ACB3B8" : "#D8D8D8",
  },
}));

type ClipperThumbComponentProps = React.HTMLAttributes<unknown>;

function ClipperThumbComponent(props: ClipperThumbComponentProps) {
  const { children, ...other } = props;
  return (
    <SliderThumb {...other}>
      {children}
      <span className="clipper-bar" />
      <span className="clipper-bar" />
    </SliderThumb>
  );
}

interface TSClippingBarProps {
  min: number;
  clipRange: number[];
  totalDuration: number;
  formattedStartTime: string;
  formattedEndTime: string;
  handleClipRange: (event: Event, value: number | number[], activeThumb: number) => void;
  // handleClippingBarMouseDown: React.MouseEventHandler<HTMLSpanElement>;
  // handleClippingBarMouseUp: (event: Event | React.SyntheticEvent<Element, Event>, value: number | number[]) => void;
  isAudioFile?: boolean;
}

const TSClippingBar = ({
  min = 0,
  clipRange,
  totalDuration,
  formattedStartTime,
  formattedEndTime,
  handleClipRange,
  // handleClippingBarMouseDown,
  // handleClippingBarMouseUp,
  isAudioFile,
}: TSClippingBarProps) => (
  <Box
    sx={{
      display: "flex",
    }}
  >
    <ClipperSlider
      min={min}
      max={totalDuration}
      value={clipRange}
      onChange={handleClipRange}
      // onMouseDown={handleClippingBarMouseDown}
      // onChangeCommitted={handleClippingBarMouseUp}
      valueLabelDisplay="auto"
      getAriaLabel={(index) => (index === 0 ? "Clip starting point" : "Clip ending point")}
      getAriaValueText={(index) => (index === 0 ? formattedStartTime : formattedEndTime)}
      valueLabelFormat={(value, index) => (index === 0 ? formattedStartTime : formattedEndTime)}
      components={{
        Thumb: ClipperThumbComponent,
      }}
      step={0.1}
      isAudioFile={isAudioFile}
    />
  </Box>
);

export default TSClippingBar;
